module.exports = __webpack_public_path__ + "img/step-7.323a75c8.jpg";